import {IUnsubscribeAll} from './types';
import {unsubscribeAll} from './services';
import {unsubcribeAllMock} from './services/createMockService/unsubscribeAllMock';
import {GetConfigFunc} from '../types';

export const createDataSyncUnsubscribeAll = (
  getConfig: GetConfigFunc,
): IUnsubscribeAll => {
  if (getConfig().Api.Mode === 'mock') {
    // Create mock pusher service
    return unsubcribeAllMock;
  } else {
    // Create REAL pusher service
    return (accessToken: string) => unsubscribeAll(accessToken, getConfig);
  }
};
